import { Button, Descriptions, Icons, Input } from '@pankod/refine-antd'
import { useTranslate } from '@pankod/refine-core'
import { useState } from 'react'
import { noteNameType } from 'types/types'

type EditableRowFieldProps = {
  record: any,
  handleSave: any,
  notename?: noteNameType
}

const getValueByNoteType = (record: any, noteType: noteNameType) => {
  switch (noteType) {
    case 'notes':
      return record?.notes
    case 'estimated_notes':
      return record?.estimated_notes
    case 'issue_comments':
      return record?.issue_comments
    default:
      return record?.location
  }
}

const getLabelByNoteType = (t: any, noteType: noteNameType) => {
  switch (noteType) {
    case 'notes':
    case 'estimated_notes':
      return t('order.fields.note')
    case 'issue_comments':
      return t('order.fields.issue_comments')
    default:
      return t('order.fields.location')
  }
}

export const EditableRowField = ({ record, handleSave, notename = 'location' }: EditableRowFieldProps) => {
  const t = useTranslate()

  const [editfield, setEditField] = useState(false)
  const [currentValue, setCurrentValue] = useState<string | undefined>(getValueByNoteType(record, notename))

  const handleEditValue = (isClose: boolean = false) => {
    if (isClose) {
      setCurrentValue(getValueByNoteType(record, notename))
      setEditField(false)
    } else {
      setEditField(!editfield)
    }
  }

  const onChangeValue = (value: any) => {
    setCurrentValue(value)
  }

  const label = getLabelByNoteType(t, notename)
  const isTextArea = notename !== 'location'

  return (!editfield)
    ? <Descriptions.Item key={(record.id || record.order_id) + currentValue} label={label}>
        <div style={{ display: 'flex', alignItems: 'initial' }}>
          <span style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{currentValue}</span>
          <Button shape='circle' style={{ border: 'none', top: -5, marginLeft: 20 }} icon={<Icons.EditOutlined />} onClick={() => handleEditValue()} />
        </div>
      </Descriptions.Item>
    : <Descriptions.Item label={label}>
        <div style={{ display: 'flex', alignItems: 'initial' }}>
          {isTextArea
            ? <Input.TextArea
                autoSize={{ minRows: 1, maxRows: 4 }}
                style={{ minWidth: '50px', maxWidth: '300px', marginLeft: 10, marginTop: -5 }}
                defaultValue={currentValue}
                onChange={(e) => onChangeValue(e.target.value)}
              />
            : <Input style={{ minWidth: '50px', maxWidth: '100px', height: '32px', marginLeft: 10, marginTop: -5 }} defaultValue={currentValue} onChange={(e) => onChangeValue(e.target.value)}/>
          }
          <Button shape='circle' style={{ border: 'none', top: -5, marginLeft: 10 }} icon={<Icons.SaveOutlined />} onClick={() => handleSave(currentValue, record, handleEditValue) } />
          <Button shape='circle' style={{ border: 'none', top: -5, marginLeft: 0 }} icon={<Icons.CloseOutlined />} onClick={() => handleEditValue(true)} />
        </div>
      </Descriptions.Item>
}
